import PropTypes from 'prop-types';
import React from 'react';
import { FormCheck } from 'react-bootstrap';

import asFormField from './asFormField';

export const RadioInput = ({
    name,
    value,
    onChange,
    onBlur,
    className,
    style,

    options,
    disabled,
}) => {
    return (
        <div className={className} style={style}>
            {options.map((opt) => (
                <FormCheck
                    type="radio"
                    key={opt.id}
                    name={name}
                    id={opt.id}
                    value={opt.id}
                    checked={opt.id === value}
                    onChange={onChange}
                    onBlur={onBlur}
                    disabled={disabled}
                    label={opt.option}
                />
            ))}
        </div>
    );
};

RadioInput.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    className: PropTypes.string,
    style: PropTypes.shape({}),

    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            option: PropTypes.node,
        })
    ).isRequired,
    disabled: PropTypes.bool,
};

RadioInput.defaultProps = {
    value: null,
    onBlur: null,
    className: '',
    style: null,

    disabled: false,
};

export const RadioField = asFormField({ WrappedComponent: React.memo(RadioInput), isFieldset: true });
